import { useMessageDialogStore } from '../../../store';

export function useComposeButtonAction() {
  const { open: openMessageDialog } = useMessageDialogStore();

  const handleClick = () => {
    openMessageDialog();
  };

  return { handleClick };
}
